import React, { useEffect } from 'react';
import { TPageProps } from './types';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { useNavigate } from 'react-router-dom';
import { setNavigateTo } from '../../store/reducer';
import { UniversalTag } from '../UniversalTag';
import { TBaseTagContext } from '../types';

export const Page: React.FC<TPageProps> = ({ page, settings }) => {
  const navigateTo = useSelector((state: RootState) => state.ui.navigateTo);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (navigateTo?.length) {
      switch (navigateTo) {
        case 'back':
          window.history.back();
          break;
        case 'forwards':
          window.history.forward();
          break;
        default:
          navigate(navigateTo);
      }
      dispatch(setNavigateTo(undefined));
    }
  }, [dispatch, navigate, navigateTo]);

  const context: Partial<TBaseTagContext> = {
    page: {
      key: page.id,
    },
    path: [],
  };

  const pageContentTag = {
    tag: '$Template',
    id: page.html || settings.uc,
  };

  return <UniversalTag tagProps={pageContentTag} context={context} />;
};
